module.exports = __webpack_public_path__ + "img/patoma.62b53751.png";